import React, { useState } from "react";
import { Loading, Switch, Text } from '@nextui-org/react';

const FeatureSelection = ({ featureList, handleSwitch }) => {
  const [switchKey, setSwitchKey] = useState(new Date().getTime());

  if (!featureList?.length) {
    return null;
  }

  return (
    <>
      {featureList.map((obj, idx) => (
        <div className="card bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 rounded-xl overflow-hidden" key={idx}>
          <div className="card-body p-4">
            <div className="card-title flex justify-between mb-3">
              <h2 className="card-title text-lg font-semibold text-gray-800">
                {obj.feature_name}
              </h2>
              <div className="flex items-center space-x-3">
                {(obj.is_feature_active === 0 || obj.is_feature_active === 1) && (
                  <Switch
                    size="sm"
                    key={switchKey}
                    checked={obj.is_feature_active === 1}
                    disabled={obj.is_mandatory === 1}
                    onChange={() => {
                      setSwitchKey(new Date().getTime()); // HACK!!
                      handleSwitch(obj);
                    }}
                  />
                )}

                {obj.coming_soon_ind ? (
                  <div className="badge badge-primary">Upcoming</div>
                ) : null}
              </div>
            </div>

            <div className="border-t border-b border-gray-100 my-4">
              <p className="text-sm text-gray-600 py-4 leading-relaxed">
                {obj.item_desc_ext}
              </p>
            </div>

            <div className="flex justify-end items-center mt-3">
              <div className="text-right">
                <span className="text-xl font-bold text-primary">
                  {obj.display_price}
                </span>
                <span className="text-sm text-gray-500 ml-1">
                  {obj.uom_desc}
                </span>
              </div>
            </div>

            {obj.is_mandatory === 1 && (
              <div className="mt-3 text-xs text-gray-500 italic">
                * This feature is mandatory
              </div>
            )}
          </div>
        </div>
      ))}
    </>
  );
};

export default FeatureSelection;